export const hasVisibleText = (html: string) => {
  // Remove all HTML tags
  const textOnly = html.replace(/<[^>]*>/g, '');

  // Remove whitespace characters (spaces, tabs, newlines, etc.)
  const cleaned = textOnly.replace(/\s+/g, '').trim();

  // If anything remains, it’s visible text
  return cleaned.length > 0;
};
